import { EGuardEntityName, ITableColumn } from '~/core/models'
import { forecastPercentNumber } from '~/utils/index'

const createColumn = function (name: string, isPercent: boolean = false, isCenter: boolean = false): ITableColumn {
  const column: ITableColumn = {
    name: name,
    key: name,
    guardEntityField: 'sector', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: `aggregationAnalysis.sectorTab.table.${name}`,
  }
  if (isPercent) {
    column.title = (v: number): string => forecastPercentNumber(v, 1)
  }
  if (isCenter) {
    column.classes = { 'text-center': true }
  }
  return column
}

export const AGGREGATION_ANALYSIS_SECTOR_COLUMNS: ITableColumn[] = [
  createColumn('sector'),
  // earnings
  createColumn('consErngsGr', true, true),
  createColumn('prxErngsGr', true, true),
  createColumn('spreadErngsGr', true, true),
  createColumn('actErngsGr', true, true),
  // revenues
  createColumn('consRevGr', true, true),
  createColumn('prxRevGr', true, true),
  createColumn('spreadRevGr', true, true),
  createColumn('actRevGr', true, true),
  // counts
  createColumn('commonCount', false, true),
]
